export default "__VITE_ASSET__DdFM0Kc6__"